export default __webpack_public_path__ + "static/media/spain-flag.b3caa695.svg";